/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { accountReducer } from "data/store/reducers/account";
import { alertReducer } from "data/store/reducers/alert";
import { applicationReducer } from "data/store/reducers/application";
import { authReducer } from "data/store/reducers/auth";
import { componentReducer } from "data/store/reducers/component";
import { composerReducer } from "data/store/reducers/composer";
import { formReducer } from "data/store/reducers/form";
import { formResponsesReducer } from "data/store/reducers/form-responses";
import { keywordReducer } from "data/store/reducers/keyword";
import { layoutReducer } from "data/store/reducers/layout";
import { menuReducer } from "data/store/reducers/menu";
import { modelReducer } from "data/store/reducers/model/model.slice";
import { orgSettingsReducer } from "data/store/reducers/org-settings";
import { organizationReducer } from "data/store/reducers/organization";
import { permissionsReducer } from "data/store/reducers/permissions";
import { publishingTargetsReducer } from "data/store/reducers/publishing-targets";
import { rolesReducer } from "data/store/reducers/roles";
import { schemaReducer } from "data/store/reducers/schema-model";
import { seoReducer } from "data/store/reducers/seo";
import { webpageReducer } from "data/store/reducers/webpage";
import { websiteReducer } from "data/store/reducers/website";
import { combineReducers } from "redux";

const reducers = combineReducers({
    account: accountReducer,
    alerts: alertReducer,
    application: applicationReducer,
    auth: authReducer,
    composer: composerReducer,
    component: componentReducer,
    form: formReducer,
    formResponse: formResponsesReducer,
    keyword: keywordReducer,
    layout: layoutReducer,
    menu: menuReducer,
    model: modelReducer,
    orgSettings: orgSettingsReducer,
    organization: organizationReducer,
    permissions: permissionsReducer,
    publishingTargets: publishingTargetsReducer,
    roles: rolesReducer,
    schemas: schemaReducer,
    seo: seoReducer,
    webpage: webpageReducer,
    website: websiteReducer,
});

export default reducers;
